<template>
  <div>
    <skeleton v-if="$_verifyLoaded('loading')" :data="data" :type="type" />
    <table-list class="product-category-best-seller" :data="data" :type="type" :empty="!data.total_count">
      <table-list-header v-if="$_verifyLoaded('done')" :title="$tc('product.category', 0)" :icon="'icon-trending-1'">
        <table-list-column class="col-6">{{ $tc('product.category', 1) }}</table-list-column>
        <table-list-column class="col-3 text-right">{{ $t('product.product_quantity') }}</table-list-column>
        <table-list-column class="col-3 text-right">{{ $t('product.total') }}</table-list-column>
      </table-list-header>
      <table-list-body :remove-last-line="true">
        <template v-if="$_verifyLoaded('done')">
          <table-list-row
            v-for="(item, index) in data.rows"
            :key="index"
            :cursor-type="'pointer'"
            :category-name="item.name"
          >
            <table-list-column class="col-6 capitalize">{{ item.name }}</table-list-column>
            <table-list-column class="col-3 text-right">{{ $_formatDecimal(item.qty, 3) }}</table-list-column>
            <table-list-column class="col-3 text-right">{{ formatCurrency(item.catRevenue) }}</table-list-column>
          </table-list-row>
          <div class="link-container row d-flex justify-content-end">
            <label
              class="link color-oto-brand-omni col-auto text-right mr-3"
              @click="openLightbox('lightbox-category-best-seller')"
              >{{ $t('product.see-more-categories') }}</label
            >
          </div>
        </template>
        <info-card v-show="$_verifyLoaded('info')" ref="message-error" :error="hasError" />
      </table-list-body>
    </table-list>
  </div>
</template>

<script>
import { getTable } from '@/services/product';
import { openLightbox } from '@/helpers/lightbox';
import bus from '@/helpers/events/bus';
import ProductsMixin from '@/helpers/mixins/productsMixin';
import CategoryBestSellerSkeleton from '@/components/products/product/ProductCategoryBestSellerSkeleton';
import InfoCard from '@/components/_atoms/InfoCard';
import { verifyMixin, numberMixin } from '@/helpers/mixins';

export default {
  name: 'ProductCategoryBestSeller',
  components: {
    skeleton: CategoryBestSellerSkeleton,
    InfoCard,
  },
  mixins: [ProductsMixin, verifyMixin, numberMixin],
  data() {
    return {
      data: {
        limit: 5,
        page: 1,
        series: [],
        rows: [],
        total_count: 0,
      },
      type: 'filled',
      days: 6,
    };
  },
  mounted() {
    this.fetchData();

    // called after a global date change or brand change
    bus.$on('render-cards', () => {
      this.fetchData();
    });
  },
  beforeUnmount() {
    bus.$off('render-cards');
  },
  methods: {
    fetchData() {
      this.$_reqConfig();

      getTable({
        table: 'categories_best_sellers',
        limit: this.data.limit,
        startDate: this.$_getSubtractedDate(this.days),
      })
        .then(({ data }) => {
          if (this.$_verifyData(data.data)) return;

          this.data.total_count = data.total_count;
          this.data.rows = [];
          this.formatRows(data.data);
        })
        .catch(() => {
          this.hasError = true;
          this.$_componentHeight();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatRows(data) {
      const resolveRows = row => {
        const [name, qty, catRevenue] = row;

        return {
          name,
          qty,
          catRevenue,
        };
      };
      data.map(item => this.data.rows.push(resolveRows(item)));
    },
    openLightbox(id) {
      openLightbox(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  cursor: pointer;
  padding: 10px;
}
</style>
